import { commonActions } from "./common-actions";
import { commonAudit } from "./common-audit";
import { commonAuth } from "./common-auth";
import { commonBoolean } from "./common-boolean";
import { commonBrand } from "./common-brand";
import { commonEnums } from "./common-enums";
import { commonFields } from "./common-fields";
import { commonFilters } from "./common-filters";
import { commonIdentityPicker } from "./common-identity-picker";
import { commonLabels } from "./common-labels";
import { commonMarkdownEditor } from "./common-markdown-editor";
import { commonMessages } from "./common-messages";
import { commonNouns } from "./common-nouns";
import { commonPlaceholders } from "./common-placeholders";
import { commonRoles } from "./common-roles";
import { commonSecurity } from "./common-security";
import { commonUnits } from "./common-units";
import { commonValidation } from "./common-validation";

export const commonCatalog = {
  brand: commonBrand,
  nouns: commonNouns,
  fields: commonFields,
  audit: commonAudit,
  labels: commonLabels,
  placeholders: commonPlaceholders,
  markdownEditor: commonMarkdownEditor,
  filters: commonFilters,
  actions: commonActions,
  identityPicker: commonIdentityPicker,
  messages: commonMessages,
  auth: commonAuth,
  validation: commonValidation,
  roles: commonRoles,
  enums: commonEnums,
  security: commonSecurity,
  boolean: commonBoolean,
  units: commonUnits,
} as const;
